import React from 'react';
import { connect } from 'react-redux';
import FilterButton from '../../components/FilterButton';
import Next from '../../static/images/btn-next.png';
import { ReactComponent as HomeIcon } from '../../static/assets/home.svg';
import { ReactComponent as ConfigIcon } from '../../static/assets/config.svg';
import { ReactComponent as IndustyIcon } from '../../static/assets/industry.svg';
import { ReactComponent as OfferingIcon } from '../../static/assets/focus.svg';
import { ReactComponent as SubOfferingIcon } from '../../static/assets/sub-offering.svg';
import { ReactComponent as ProcessIcon } from '../../static/assets/process.svg';
import { ReactComponent as RegionIcon } from '../../static/assets/world.svg';
import { getIndustries, getOfferings, getSubOfferings, getRegions, setSelectedFilterName,
         getProcesses, setProcess, incrementStatistic, setActiveFilterName,
         setRegion, resetAll, setIndustry } from '../../utils/filter/actions';
import { getDataSet } from '../../utils/dataSet/actions';
import {PREFIX_URL} from "../../constants";


class BasicConfiguration extends React.Component {
  state = {
    isMounted: true,
    optionsOpened: false,

    industryOptionsVisible: false,
    offeringOptionsVisible: false,
    subOfferingOptionsVisible: false,
    processOptionsVisible: false,
    regionOptionsVisible: false,

    industryOptionsSelected: false,
    offeringOptionsSelected: false,
    subOfferingOptionsSelected: false,
    processOptionsSelected: false,
    regionOptionsSelected: false,

    industryOptionsVisibleDiv: false,
    offeringOptionsVisibleDiv: false,
    subOfferingOptionsVisibleDiv: false,
    processOptionsVisibleDiv: false,
    regionOptionsVisibleDiv: false,

    'filter-history-popover': false,
  }

  componentDidMount(){
    this.props.getIndustries();
  }

  handleClick = (event) => {
    const name = event.currentTarget.getAttribute('name');
    this.setState({ optionsOpened: true });
    switch (name) {
      case 'industries':
        this.setState({ industryOptionsVisible: true });
        this.setState({ industryOptionsSelected: true });
        this.setState({ industryOptionsVisibleDiv: true });
        break
      case 'offerings':
        this.setState({ offeringOptionsVisible: true });
        this.setState({ offeringOptionsSelected: true });
        this.setState({ offeringOptionsVisibleDiv: true });
        break;
      case 'subOfferings':
        this.setState({ subOfferingOptionsVisible: true });
        this.setState({ subOfferingOptionsSelected: true });
        this.setState({ subOfferingOptionsVisibleDiv: true });
        break;
      case 'processes':
        this.setState({ processOptionsVisible: true });
        this.setState({ processOptionsSelected: true });
        this.setState({ processOptionsVisibleDiv: true });
        break;
      case 'regions':
        this.setState({ regionOptionsVisible: true });
        this.setState({ regionOptionsSelected: true });
        this.setState({ regionOptionsVisibleDiv: true });
        break;
      default:
        return;
    }
  }

  handleClickOption = (event) => {
    const type = event.currentTarget.getAttribute('name');
    const value = event.currentTarget.getAttribute('value');
    const id = event.currentTarget.getAttribute('id');
    this.awaitBeforeSetState(this, 'optionsOpened', false, 1250);
    switch (type) {
      case 'industry':
        this.awaitBeforeSetState(this, 'industryOptionsVisibleDiv', false, 1250);
        this.props.getOfferings();
        this.props.setIndustry(id);
        break;
      case 'offering':
        this.awaitBeforeSetState(this, 'offeringOptionsVisibleDiv', false, 1250);
        this.props.getSubOfferings(id);
        break;
      case 'subOffering':
        this.awaitBeforeSetState(this, 'subOfferingOptionsVisibleDiv', false, 1250);
        this.props.getProcesses(id);
        break;
      case 'process':
        this.awaitBeforeSetState(this, 'processOptionsVisibleDiv', false, 1250);
        this.props.getRegions();
        this.props.setProcess(id);
        break;
      case 'region':
        this.awaitBeforeSetState(this, 'regionOptionsVisibleDiv', false, 1250);
        this.awaitBeforeSetState(this, 'regionId', id, 1250);
        this.props.setRegion(id);
        incrementStatistic('regions', id);
        break;
      default:
        return;
    }
    this.props.setActiveFilterName(type, value);
    this.awaitBeforeSetProp({type, name: value}, 1250, this.props.setSelectedFilterName);

    this.setState({ industryOptionsVisible: false });
    this.setState({ offeringOptionsVisible: false });
    this.setState({ subOfferingOptionsVisible: false });
    this.setState({ processOptionsVisible: false });
    this.setState({ regionOptionsVisible: false });

    this.awaitBeforeSetState(this, 'industryOptionsSelected', false, 1000);
    this.awaitBeforeSetState(this, 'offeringOptionsSelected', false, 1000);
    this.awaitBeforeSetState(this, 'subOfferingOptionsSelected', false, 1000);
    this.awaitBeforeSetState(this, 'processOptionsSelected', false, 1000);
    this.awaitBeforeSetState(this, 'regionOptionsSelected', false, 1000);
  }

  handleInfoClick = (event) => {
    event.stopPropagation();
    const id = event.currentTarget.getAttribute('id');
    if (id === 'filter-history-popover' && this.state['filter-history-popover']) {
      this.setState({ 'filter-history-popover': false });
    } else if (id === 'filter-history-popover') {
      this.setState({ 'filter-history-popover': true });
    }
  }

  handleResetClick = (event) => {
    event.stopPropagation();
    this.setState({ 'filter-history-popover': false });
    this.setState({ isMounted: false });
    this.awaitBeforeCallback(2000, this.props.resetAll);
  }

  awaitBeforeCallback(time, callback) {
    setTimeout(function() {
      callback();
    }, time)
  }

  handleItemClick = (event) => {
    const name = event.currentTarget.getAttribute('name');
    const id = event.currentTarget.getAttribute('id');
    let newPath;
    if (name === 'start') {
      newPath = PREFIX_URL;
    } else {
        newPath = `${PREFIX_URL}${name}`;
    }
    if (id) {
      this.props.getDataSet(id);
    }
    if (this.props.history.location.pathname !== newPath) {
      this.setState({ isMounted: false });
      this.awaitBeforeHistoryPush(newPath, 2000, this.props.history.push);
    }
  }

  awaitBeforeHistoryPush(newPath, time, callback) {
    setTimeout(function() {
      callback(newPath);
    }, time)
  }

  awaitBeforeSetState(that, key, value, time) {
    setTimeout(function() {
      that.setState({ [key]: value });
    }, time);
  }

  awaitBeforeSetProp(value, time, callback) {
    setTimeout(function() {
      callback(value);
    }, time);
  }

  render() {
    const {
      optionsOpened,

      industryOptionsVisible,
      offeringOptionsVisible,
      subOfferingOptionsVisible,
      processOptionsVisible,
      regionOptionsVisible,

      industryOptionsVisibleDiv,
      offeringOptionsVisibleDiv,
      subOfferingOptionsVisibleDiv,
      processOptionsVisibleDiv,
      regionOptionsVisibleDiv,

      industryOptionsSelected,
      offeringOptionsSelected,
      subOfferingOptionsSelected,
      processOptionsSelected,
      regionOptionsSelected,
    } = this.state;
    const {
      industries,
      offerings,
      subOfferings,
      processes,
      regions,

      processId,

      activeIndustry,
      activeOffering,
      activeSubOffering,
      activeProcess,
      activeRegion,

      industrySelected,
      offeringSelected,
      subOfferingSelected,
      processSelected,
      regionSelected,
    } = this.props;
    return (
      <div className="h-100 w-100 overflow-hidden">
        <div className={`container-fluid filters-container ${this.state.isMounted ? '' : 'unmounting'}`}>
          <HomeIcon onClick={this.handleItemClick} name="start" className="home-button navigation-button" />
          <ConfigIcon onClick={this.handleInfoClick} id="filter-history-popover" className="config-button navigation-button" />
          <div className="info-popover history-popover" style={this.state["filter-history-popover"] ? {opacity: 1} : {opacity: 0, display: 'none'} } >
            <p>Industry:</p>
            <p className="name">{activeIndustry}</p>
            <p>Offering:</p>
            <p className="name">{activeOffering}</p>
            <p>Sub-Offering:</p>
            <p className="name">{activeSubOffering}</p>
            <p>Process:</p>
            <p className="name">{activeProcess}</p>
            <p>Business Region:</p>
            <p className="name">{activeRegion}</p>
            <button onClick={this.handleResetClick} className="btn reset-btn btn-block">Reset</button>
          </div>
          <div className="main-header-container">
            <h1 className="main-header">
              <span className="header-border header-border-left"></span>
                Process Maturity Matrix
              <span className="header-border header-border-right"></span>
            </h1>
          </div>
          <div className="secondary-header-container">
            <h2 className="secondary-header">
              Basic configuration
            </h2>
          </div>
          <div className={`container-fluid h-100 inner-filters-container ${optionsOpened ? 'options-opened' : ''}`}>
            <div className="row h-100">
              <div className={`
                col h-100 rotating-reversed industries
                ${industrySelected ? 'selected' : ''}
                ${industryOptionsVisibleDiv ? 'visible' : ''}`}>
                <span className={`instruction-message ${!offeringSelected && !industrySelected ? 'show-message' : '' }`} >
                  Select an industry
                </span>
                <FilterButton
                  text={ industrySelected ? industrySelected : 'Industry' }
                  name="industries"
                  className="filter-button"
                  Icon={IndustyIcon}
                  isVisible={true}
                  isSelected={industryOptionsSelected}
                  isDisabled={optionsOpened}
                  handleClick={this.handleClick}
                />

                { industries[0] ?
                  <FilterButton
                    className={`
                      option option-1
                      ${activeOffering === industries[0]['label'] ? 'selected' : ''}
                      ${industries[0]['is_disabled'] ? 'disabled' : ''}
                    `}
                    isOption={true}
                    text={industries[0]['label']}
                    value={industries[0]['id']}
                    isSelected={industries[0]['id'] === offeringSelected}
                    isVisible={industryOptionsVisible}
                    name='industry'
                    handleClick={industries[0]['is_disabled'] ? null : this.handleClickOption}
                    delayIn={0}
                    customStyle={{ top: '5%', left: '100%' }}
                  /> :
                  null }
                { industries[1] ?
                  <FilterButton
                    className={`
                      option option-6
                      ${activeOffering === industries[1]['label'] ? 'selected' : ''}
                      ${industries[1]['is_disabled'] ? 'disabled' : ''}
                    `}
                    isOption={true}
                    text={industries[1]['label']}
                    value={industries[1]['id']}
                    isVisible={industryOptionsVisible}
                    name='industry'
                    handleClick={industries[1]['is_disabled'] ? null : this.handleClickOption}
                    delayIn={250}
                    customStyle={{ bottom: '-10%', left: '100%' }}
                  /> :
                  null }

                { industries[2] ?
                  <FilterButton
                    className={`
                      option option-2
                      ${activeOffering === industries[2]['label'] ? 'selected' : ''}
                      ${industries[2]['is_disabled'] ? 'disabled' : ''}
                    `}
                    isOption={true}
                    text={industries[2]['label']}
                    value={industries[2]['id']}
                    isVisible={industryOptionsVisible}
                    name='industry'
                    handleClick={industries[2]['is_disabled'] ? null : this.handleClickOption}
                    delayIn={500}
                    customStyle={{ top: '7%', left: '200%' }}
                  /> :
                  null }
                { industries[3] ?
                  <FilterButton
                    className={`
                      option option-7
                      ${activeOffering === industries[3]['label'] ? 'selected' : ''}
                      ${industries[3]['is_disabled'] ? 'disabled' : ''}
                    `}
                    isOption={true}
                    text={industries[3]['label']}
                    value={industries[3]['id']}
                    isVisible={industryOptionsVisible}
                    name='industry'
                    handleClick={industries[3]['is_disabled'] ? null : this.handleClickOption}
                    delayIn={750}
                    customStyle={{ bottom: '-7%', left: '200%' }}
                  /> :
                  null }

                { industries[4] ?
                  <FilterButton
                    className={`
                      option option-3
                      ${activeOffering === industries[4]['label'] ? 'selected' : ''}
                      ${industries[4]['is_disabled'] ? 'disabled' : ''}
                    `}
                    isOption={true}
                    text={industries[4]['label']}
                    value={industries[4]['id']}
                    isVisible={industryOptionsVisible}
                    name='industry'
                    handleClick={industries[4]['is_disabled'] ? null : this.handleClickOption}
                    delayIn={1000}
                    customStyle={{ top: '10%', left: '300%' }}
                  /> :
                  null }
                { industries[5] ?
                  <FilterButton
                    className={`
                      option option-8
                      ${activeOffering === industries[5]['label'] ? 'selected' : ''}
                      ${industries[5]['is_disabled'] ? 'disabled' : ''}
                    `}
                    isOption={true}
                    text={industries[5]['label']}
                    value={industries[5]['id']}
                    isVisible={industryOptionsVisible}
                    name='industry'
                    handleClick={industries[5]['is_disabled'] ? null : this.handleClickOption}
                    delayIn={1250}
                    customStyle={{ bottom: '-5%', left: '300%' }}
                  /> :
                  null }
                { industries[6] ?
                  <FilterButton
                    className={`
                      option option-9
                      ${activeOffering === industries[6]['label'] ? 'selected' : ''}
                      ${industries[6]['is_disabled'] ? 'disabled' : ''}
                    `}
                    isOption={true}
                    text={industries[6]['label']}
                    value={industries[6]['id']}
                    isVisible={industryOptionsVisible}
                    name='industry'
                    handleClick={industries[6]['is_disabled'] ? null : this.handleClickOption}
                    delayIn={1500}
                    customStyle={{ top: '13%', left: '400%' }}
                  /> :
                  null }
                { industries[7] ?
                  <FilterButton
                    className={`
                      option option-10
                      ${activeOffering === industries[7]['label'] ? 'selected' : ''}
                      ${industries[7]['is_disabled'] ? 'disabled' : ''}
                    `}
                    isOption={true}
                    text={industries[7]['label']}
                    value={industries[7]['id']}
                    isVisible={industryOptionsVisible}
                    name='industry'
                    handleClick={industries[7]['is_disabled'] ? null : this.handleClickOption}
                    delayIn={1500}
                    customStyle={{ bottom: '-2%', left: '400%' }}
                  /> :
                  null }

              </div>
              <div
                className={`
                  col h-100 rotating regions
                  ${!industrySelected || offerings.length === 0 ? 'disabled' : ''}
                  ${offeringSelected ? 'selected' : ''}
                  ${offeringOptionsVisibleDiv ? 'visible' : ''}`}
              >
                <span className={`instruction-message ${!subOfferingSelected && !offeringSelected && industrySelected ? 'show-message' : '' }`} >
                  Select an offering
                </span>
                <FilterButton
                  text={ offeringSelected ? offeringSelected : 'Offering' }
                  name="offerings"
                  className="filter-button"
                  Icon={OfferingIcon}
                  isVisible={true}
                  isSelected={offeringOptionsSelected}
                  isDisabled={optionsOpened}
                  handleClick={this.handleClick}
                />

                { offerings[0] ?
                  <FilterButton
                    className={`
                      option option-1
                      ${activeOffering === offerings[0]['label'] ? 'selected' : ''}
                      ${offerings[0]['is_disabled'] ? 'disabled' : ''}
                    `}
                    isOption={true}
                    text={offerings[0]['label']}
                    value={offerings[0]['id']}
                    isSelected={offerings[0]['id'] === offeringSelected}
                    isVisible={offeringOptionsVisible}
                    name='offering'
                    handleClick={offerings[0]['is_disabled'] ? null : this.handleClickOption}
                    delayIn={0}
                    customStyle={{ top: '5%', left: '100%' }}
                  /> :
                  null }
                { offerings[1] ?
                  <FilterButton
                    className={`
                      option option-6
                      ${activeOffering === offerings[1]['label'] ? 'selected' : ''}
                      ${offerings[1]['is_disabled'] ? 'disabled' : ''}
                    `}
                    isOption={true}
                    text={offerings[1]['label']}
                    value={offerings[1]['id']}
                    isVisible={offeringOptionsVisible}
                    name='offering'
                    handleClick={offerings[1]['is_disabled'] ? null : this.handleClickOption}
                    delayIn={250}
                    customStyle={{ bottom: '-10%', left: '100%' }}
                  /> :
                  null }

                { offerings[2] ?
                  <FilterButton
                    className={`
                      option option-2
                      ${activeOffering === offerings[2]['label'] ? 'selected' : ''}
                      ${offerings[2]['is_disabled'] ? 'disabled' : ''}
                    `}
                    isOption={true}
                    text={offerings[2]['label']}
                    value={offerings[2]['id']}
                    isVisible={offeringOptionsVisible}
                    name='offering'
                    handleClick={offerings[2]['is_disabled'] ? null : this.handleClickOption}
                    delayIn={500}
                    customStyle={{ top: '7%', left: '200%' }}
                  /> :
                  null }
                { offerings[3] ?
                  <FilterButton
                    className={`
                      option option-7
                      ${activeOffering === offerings[3]['label'] ? 'selected' : ''}
                      ${offerings[3]['is_disabled'] ? 'disabled' : ''}
                    `}
                    isOption={true}
                    text={offerings[3]['label']}
                    value={offerings[3]['id']}
                    isVisible={offeringOptionsVisible}
                    name='offering'
                    handleClick={offerings[3]['is_disabled'] ? null : this.handleClickOption}
                    delayIn={750}
                    customStyle={{ bottom: '-7%', left: '200%' }}
                  /> :
                  null }

                { offerings[4] ?
                  <FilterButton
                    className={`
                      option option-3
                      ${activeOffering === offerings[4]['label'] ? 'selected' : ''}
                      ${offerings[4]['is_disabled'] ? 'disabled' : ''}
                    `}
                    isOption={true}
                    text={offerings[4]['label']}
                    value={offerings[4]['id']}
                    isVisible={offeringOptionsVisible}
                    name='offering'
                    handleClick={offerings[4]['is_disabled'] ? null : this.handleClickOption}
                    delayIn={1000}
                    customStyle={{ top: '10%', left: '300%' }}
                  /> :
                  null }
                { offerings[5] ?
                  <FilterButton
                    className={`
                      option option-8
                      ${activeOffering === offerings[5]['label'] ? 'selected' : ''}
                      ${offerings[5]['is_disabled'] ? 'disabled' : ''}
                    `}
                    isOption={true}
                    text={offerings[5]['label']}
                    value={offerings[5]['id']}
                    isVisible={offeringOptionsVisible}
                    name='offering'
                    handleClick={offerings[5]['is_disabled'] ? null : this.handleClickOption}
                    delayIn={1250}
                    customStyle={{ bottom: '-5%', left: '300%' }}
                  /> :
                  null }

              </div>
              <div
                className={
                  `col h-100 rotating-reversed offerings
                  ${!offeringSelected || subOfferings.length === 0 ? 'disabled' : ''}
                  ${subOfferingOptionsVisibleDiv ? 'visible' : ''}
                  ${subOfferingSelected ? 'selected' : ''}`
                }
              >
                <span className={`instruction-message ${!processSelected && offeringSelected && !subOfferingSelected ? 'show-message' : '' }`} >
                  Select a sub-offering
                </span>
                <FilterButton
                  text={ subOfferingSelected ? subOfferingSelected : 'Sub offering' }
                  isDisabled={!offeringSelected || optionsOpened || offerings.length === 0}
                  className="filter-button"
                  Icon={SubOfferingIcon}
                  isVisible={true}
                  isSelected={subOfferingOptionsSelected}
                  name="subOfferings"
                  handleClick={this.handleClick}
                />

                { subOfferings[0] ?
                  <FilterButton
                    className={`
                      option option-1
                      ${activeSubOffering === subOfferings[0]['label'] ? 'selected' : ''}
                      ${subOfferings[0]['is_disabled'] ? 'disabled' : ''}
                    `}
                    isOption={true}
                    text={subOfferings[0]['label']}
                    value={subOfferings[0]['id']}
                    isVisible={subOfferingOptionsVisible}
                    name='subOffering'
                    handleClick={subOfferings[0]['is_disabled'] ? null : this.handleClickOption}
                    delayIn={0}
                    customStyle={{ top: '5%', left: '-50%' }}
                  /> :
                  null }
                { subOfferings[1] ?
                  <FilterButton
                    className={`
                      option option-6
                      ${activeSubOffering === subOfferings[1]['label'] ? 'selected' : ''}
                      ${subOfferings[1]['is_disabled'] ? 'disabled' : ''}
                    `}
                    isOption={true}
                    text={subOfferings[1]['label']}
                    value={subOfferings[1]['id']}
                    isVisible={subOfferingOptionsVisible}
                    name='subOffering'
                    handleClick={subOfferings[1]['is_disabled'] ? null : this.handleClickOption}
                    delayIn={250}
                    customStyle={{ bottom: '-10%', left: '-50%' }}
                  /> :
                  null }

                { subOfferings[2] ?
                  <FilterButton
                    className={`
                      option option-2
                      ${activeSubOffering === subOfferings[2]['label'] ? 'selected' : ''}
                      ${subOfferings[2]['is_disabled'] ? 'disabled' : ''}
                    `}
                    isOption={true}
                    text={subOfferings[2]['label']}
                    value={subOfferings[2]['id']}
                    isVisible={subOfferingOptionsVisible}
                    name='subOffering'
                    handleClick={subOfferings[2]['is_disabled'] ? null : this.handleClickOption}
                    delayIn={500}
                    customStyle={{ top: '5%', left: '100%' }}
                  /> :
                  null }
                { subOfferings[3] ?
                  <FilterButton
                    className={`
                      option option-7
                      ${activeSubOffering === subOfferings[3]['label'] ? 'selected' : ''}
                      ${subOfferings[3]['is_disabled'] ? 'disabled' : ''}
                    `}
                    isOption={true}
                    text={subOfferings[3]['label']}
                    value={subOfferings[3]['id']}
                    isVisible={subOfferingOptionsVisible}
                    name='subOffering'
                    handleClick={subOfferings[3]['is_disabled'] ? null : this.handleClickOption}
                    delayIn={750}
                    customStyle={{ bottom: '-10%', left: '100%' }}
                  /> :
                  null }

                { subOfferings[4] ?
                  <FilterButton
                    className={`
                      option option-3
                      ${activeSubOffering === subOfferings[4]['label'] ? 'selected' : ''}
                      ${subOfferings[4]['is_disabled'] ? 'disabled' : ''}
                    `}
                    isOption={true}
                    text={subOfferings[4]['label']}
                    value={subOfferings[4]['id']}
                    isVisible={subOfferingOptionsVisible}
                    name='subOffering'
                    handleClick={subOfferings[4]['is_disabled'] ? null : this.handleClickOption}
                    delayIn={1000}
                    customStyle={{ top: '7%', left: '200%' }}
                  /> :
                  null }
                { subOfferings[5] ?
                  <FilterButton
                    className={`
                      option option-8
                      ${activeSubOffering === subOfferings[5]['label'] ? 'selected' : ''}
                      ${subOfferings[5]['is_disabled'] ? 'disabled' : ''}
                    `}
                    isOption={true}
                    text={subOfferings[5]['label']}
                    value={subOfferings[5]['id']}
                    isVisible={subOfferingOptionsVisible}
                    name='subOffering'
                    handleClick={subOfferings[5]['is_disabled'] ? null : this.handleClickOption}
                    delayIn={1250}
                    customStyle={{ bottom: '-7%', left: '200%' }}
                  /> :
                  null }
              </div>
              <div
                className={
                  `col h-100 rotating sub-offerings
                  ${(!subOfferingSelected || !offeringSelected || subOfferings.length === 0) ? 'disabled' : ''}
                  ${processOptionsVisibleDiv ? 'visible' : ''}
                  ${processSelected ? 'selected' : ''}`
                }
              >
                <span className={`instruction-message ${!regionSelected && subOfferingSelected && !processSelected ? 'show-message' : '' }`} >
                  Select a process
                </span>
                <FilterButton
                  text={ processSelected ? processSelected : 'Process' }
                  isDisabled={(!subOfferingSelected || !offeringSelected || optionsOpened || subOfferings.length === 0)}
                  Icon={ProcessIcon}
                  isVisible={true}
                  isSelected={processOptionsSelected}
                  className="filter-button"
                  name="processes"
                  handleClick={this.handleClick}
                />

                { processes[0] ?
                  <FilterButton
                    className={`
                      option option-1
                      ${activeProcess === processes[0]['label'] ? 'selected' : ''}
                      ${processes[0]['is_disabled'] ? 'disabled' : ''}
                    `}
                    isOption={true}
                    text={processes[0]['label']}
                    value={processes[0]['id']}
                    isVisible={processOptionsVisible}
                    name='process'
                    handleClick={processes[0]['is_disabled'] ? null : this.handleClickOption}
                    delayIn={0}
                    customStyle={{ top: '7%', left: '-150%' }}
                  /> :
                  null }
                { processes[1] ?
                  <FilterButton
                    className={`
                      option option-6
                      ${activeProcess === processes[1]['label'] ? 'selected' : ''}
                      ${processes[1]['is_disabled'] ? 'disabled' : ''}
                    `}
                    isOption={true}
                    text={processes[1]['label']}
                    value={processes[1]['id']}
                    isVisible={processOptionsVisible}
                    name='process'
                    handleClick={processes[1]['is_disabled'] ? null : this.handleClickOption}
                    delayIn={250}
                    customStyle={{ bottom: '-7%', left: '-150%' }}
                  /> :
                  null }

                { processes[2] ?
                  <FilterButton
                    className={`
                      option option-2
                      ${activeProcess === processes[2]['label'] ? 'selected' : ''}
                      ${processes[2]['is_disabled'] ? 'disabled' : ''}
                    `}
                    isOption={true}
                    text={processes[2]['label']}
                    value={processes[2]['id']}
                    isVisible={processOptionsVisible}
                    name='process'
                    handleClick={processes[2]['is_disabled'] ? null : this.handleClickOption}
                    delayIn={500}
                    customStyle={{ top: '5%', left: '-50%' }}
                  /> :
                  null }
                { processes[3] ?
                  <FilterButton
                    className={`
                      option option-7
                      ${activeProcess === processes[3]['label'] ? 'selected' : ''}
                      ${processes[3]['is_disabled'] ? 'disabled' : ''}
                    `}
                    isOption={true}
                    text={processes[3]['label']}
                    value={processes[3]['id']}
                    isVisible={processOptionsVisible}
                    name='process'
                    handleClick={processes[3]['is_disabled'] ? null : this.handleClickOption}
                    delayIn={750}
                    customStyle={{ bottom: '-10%', left: '-50%' }}
                  /> :
                  null }

                { processes[4] ?
                  <FilterButton
                    className={`
                      option option-3
                      ${activeProcess === processes[4]['label'] ? 'selected' : ''}
                      ${processes[4]['is_disabled'] ? 'disabled' : ''}`}
                    isOption={true}
                    text={processes[4]['label']}
                    value={processes[4]['id']}
                    isVisible={processOptionsVisible}
                    name='process'
                    handleClick={processes[4]['is_disabled'] ? null : this.handleClickOption}
                    delayIn={1000}
                    customStyle={{ top: '5%', left: '100%' }}
                  /> :
                  null }
                { processes[5] ?
                  <FilterButton
                    className={`
                      option option-8
                      ${activeProcess === processes[5]['label'] ? 'selected' : ''}
                      ${processes[5]['is_disabled'] ? 'disabled' : ''}
                    `}
                    isOption={true}
                    text={processes[5]['label']}
                    value={processes[5]['id']}
                    isVisible={processOptionsVisible}
                    name='process'
                    handleClick={processes[5]['is_disabled'] ? null : this.handleClickOption}
                    delayIn={1250}
                    customStyle={{ bottom: '-10%', left: '100%' }}
                  /> :
                  null }
              </div>
              <div
                className={
                  `col h-100 rotating-reversed processes
                  ${(!processSelected || !offeringSelected || !subOfferingSelected || regions.length === 0) ? 'disabled' : ''}
                  ${regionOptionsVisibleDiv ? 'visible' : ''}
                  ${regionSelected ? 'selected' : ''}`
                }
              >
                <span className={`instruction-message ${processSelected && !regionSelected ? 'show-message' : '' }`} >
                  Select a client business region
                </span>
                <FilterButton
                  text={ regionSelected ? regionSelected : 'Business Region' }
                  isDisabled={!processSelected || !offeringSelected || !subOfferingSelected || optionsOpened || regions.length === 0}
                  isVisible={true}
                  Icon={RegionIcon}
                  isSelected={regionOptionsSelected}
                  className="filter-button"
                  name="regions"
                  handleClick={this.handleClick}
                />
                { regions[0] ?
                  <FilterButton
                    className={`
                      option option-1 region-select-button
                      ${activeRegion === regions[0]['label'] ? 'selected' : ''}
                      ${regions[0]['is_disabled'] ? 'disabled' : ''}
                    `}
                    isOption={true}
                    text={regions[0]['label']}
                    value={regions[0]['id']}
                    isVisible={regionOptionsVisible}
                    iconUrl={regions[0]['icon_url']}
                    isSelected={regions[0]['id'] === regionOptionsSelected}
                    name='region'
                    handleClick={regions[0]['is_disabled'] ? null : this.handleClickOption}
                    delayIn={0}
                    customStyle={{ top: '10%', left: '-250%' }}
                  /> :
                  null }
                { regions[1] ?
                  <FilterButton
                    className={`
                      option option-6 region-select-button
                      ${activeRegion === regions[1]['label'] ? 'selected' : ''}
                      ${regions[1]['is_disabled'] ? 'disabled' : ''}
                    `}
                    isOption={true}
                    text={regions[1]['label']}
                    value={regions[1]['id']}
                    isVisible={regionOptionsVisible}
                    iconUrl={regions[1]['icon_url']}
                    isSelected={regions[1]['id'] === regionOptionsSelected}
                    name='region'
                    handleClick={regions[1]['is_disabled'] ? null : this.handleClickOption}
                    delayIn={250}
                    customStyle={{ bottom: '-5%', left: '-250%' }}
                  /> :
                  null }

                { regions[2] ?
                  <FilterButton
                    className={`
                      option option-2 region-select-button
                      ${activeRegion === regions[2]['label'] ? 'selected' : ''}
                      ${regions[2]['is_disabled'] ? 'disabled' : ''}
                    `}
                    isOption={true}
                    text={regions[2]['label']}
                    value={regions[2]['id']}
                    isVisible={regionOptionsVisible}
                    iconUrl={regions[2]['icon_url']}
                    isSelected={regions[2]['id'] === regionOptionsSelected}
                    name='region'
                    handleClick={regions[2]['is_disabled'] ? null : this.handleClickOption}
                    delayIn={500}
                    customStyle={{ top: '7%', left: '-150%' }}
                  /> :
                  null }
                { regions[3] ?
                  <FilterButton
                    className={`
                      option option-7 region-select-button
                      ${activeRegion === regions[3]['label'] ? 'selected' : ''}
                      ${regions[3]['is_disabled'] ? 'disabled' : ''}
                    `}
                    isOption={true}
                    text={regions[3]['label']}
                    value={regions[3]['id']}
                    isVisible={regionOptionsVisible}
                    iconUrl={regions[3]['icon_url']}
                    isSelected={regions[3]['id'] === regionOptionsSelected}
                    name='region'
                    handleClick={regions[3]['is_disabled'] ? null : this.handleClickOption}
                    delayIn={750}
                    customStyle={{ bottom: '-7%', left: '-150%' }}
                  /> :
                  null }

                { regions[4] ?
                  <FilterButton
                    className={`
                      option option-3 region-select-button
                      ${activeRegion === regions[4]['label'] ? 'selected' : ''}
                      ${regions[4]['is_disabled'] ? 'disabled' : ''}
                    `}
                    isOption={true}
                    text={regions[4]['label']}
                    value={regions[4]['id']}
                    isVisible={regionOptionsVisible}
                    iconUrl={regions[4]['icon_url']}
                    isSelected={regions[4]['id'] === regionOptionsSelected}
                    name='region'
                    handleClick={regions[4]['is_disabled'] ? null : this.handleClickOption}
                    delayIn={1000}
                    customStyle={{ top: '5%', left: '-50%' }}
                  /> :
                  null }
                { regions[5] ?
                  <FilterButton
                    className={`
                      option option-8 region-select-button
                      ${activeRegion === regions[5]['label'] ? 'selected' : ''}
                      ${regions[5]['is_disabled'] ? 'disabled' : ''}
                    `}
                    isOption={true}
                    text={regions[5]['label']}
                    value={regions[5]['id']}
                    isVisible={regionOptionsVisible}
                    iconUrl={regions[5]['icon_url']}
                    isSelected={regions[5]['id'] === regionOptionsSelected}
                    name='region'
                    handleClick={regions[5]['is_disabled'] ? null : this.handleClickOption}
                    delayIn={1250}
                    customStyle={{ bottom: '-10%', left: '-50%' }}
                  /> :
                  null }
              </div>
            </div>
          </div>
          <div className="next-container">
            <div
              className={
                `next-button
                ${(!regionSelected || !offeringSelected || !processSelected || !subOfferingSelected || optionsOpened) ? 'disabled' : 'cursor-pointer'}
              `}
              name="business-outcome-indicators"
              id={processId}
              onClick={(!regionSelected || !offeringSelected || !processSelected || !subOfferingSelected || optionsOpened) ? null : this.handleItemClick}
            >
              <img className="next-button-img" src={Next} alt="next" />
              <span>Next</span>
            </div>
          </div>
          <div className="business-outcome-footer footer">
            <p>Business outcome indicators</p>
          </div>
          <div className="lead-footer footer">
            <p>Lead indicators</p>
          </div>
          <div className="results-footer footer">
            <p>Results</p>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    industries: state.filter.industries,
    offerings: state.filter.offerings,
    subOfferings: state.filter.subOfferings,
    processes: state.filter.processes,
    regions: state.filter.regions,

    processId: state.filter.processId,

    industrySelected: state.filter.industrySelected,
    offeringSelected: state.filter.offeringSelected,
    subOfferingSelected: state.filter.subOfferingSelected,
    processSelected: state.filter.processSelected,
    regionSelected: state.filter.regionSelected,

    activeIndustry: state.filter.activeIndustry,
    activeOffering: state.filter.activeOffering,
    activeSubOffering: state.filter.activeSubOffering,
    activeProcess: state.filter.activeProcess,
    activeRegion: state.filter.activeRegion,

  };
}

function mapDispatchToProps(dispatch) {
  return {
    getRegions() {
      dispatch(getRegions());
    },
    getIndustries() {
      dispatch(getIndustries());
    },
    getOfferings() {
      dispatch(getOfferings());
    },
    getSubOfferings(id) {
      dispatch(getSubOfferings(id));
    },
    getProcesses(id) {
      dispatch(getProcesses(id));
    },
    setProcess(id) {
      dispatch(setProcess(id));
    },
    getDataSet(id) {
      dispatch(getDataSet(id));
    },
    setActiveFilterName(type, name) {
      dispatch(setActiveFilterName(type, name));
    },
    setSelectedFilterName(type, name) {
      dispatch(setSelectedFilterName(type, name));
    },
    setRegion(id) {
      dispatch(setRegion(id));
    },
    setIndustry(id) {
      dispatch(setIndustry(id));
    },
    resetAll() {
      dispatch(resetAll());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BasicConfiguration);
